module.exports = __webpack_public_path__ + "img/fb.2b9d5ae7.svg";